import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import LTTPodcastNavbarmenu from "../PodCastFolder/LTTPodcastNavbarmenu";
import PodcastSideNavbar from "../PodCastFolder/PodcastSideNavbar";
import AOS from "aos";
import "aos/dist/aos.css";
import "./TracksContent.css";

function TracksContent() {
  return (
    <>
      <div className="navbar-holder podcast-navbar-holder">
        <LTTPodcastNavbarmenu />
      </div>
      <div className="podcast-sidenavbar-holder">
        <PodcastSideNavbar />
      </div>
      <div className="podcast-banner-container" id="main">
        <title>L-TT Podcast Tracks/Markets</title>
        <h1 class="sr-only" tabIndex={0}>
          Tracks Markets
        </h1>
        <img
          src={
            process.env.PUBLIC_URL +
            "/images/RoleAligned/coming-soon-banner.png"
          }
          alt="about-banner"
          className="banner-img"
        />
        <ul className="breadcrumbs">
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Home"
            >
              L&TT Home
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/LTT-Podcast"
            >
              L&TT Podcast
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Tracks-Markets"
            >
              Tracks/Markets
            </NavLink>
          </li>
        </ul>
      </div>
      {/* <h2 className="under-construction">Under Construction</h2> */}
    </>
  );
}

export default TracksContent;
